generateCartUrl = (optionuuid, dealuuid) ->
  return "/cart/add/#{optionuuid}?deal_id=#{dealuuid}"

if window?
  window.Cart  ?= {}
  Cart.Helpers ?= {}
  Cart.Helpers.generateCartUrl = generateCartUrl

if module?
  module.exports = {generateCartUrl}



// WEBPACK FOOTER //
// ./modules/cart/common/helpers.coffee